import { render } from "./ElNavigationWrapper.vue?vue&type=template&id=77e6890d&lang=html"
import script from "./ElNavigationWrapper.vue?vue&type=script&lang=js"
export * from "./ElNavigationWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__